export default __webpack_public_path__ + "static/media/aped-call.837cfba3.svg";